import { Case } from '@/api/apis/case';
import { getOutcomeString } from '../../utils';

export const CaseOutcome = ({ caseData }: { caseData: Case }) => {
  const outcomeString = getOutcomeString(caseData);

  return outcomeString ? <div className="text-s-cps text-base-30">{outcomeString}</div> : null;
};
